// Dev (deployed) environment. tenantId comes from the logged-in user's session, not config.
export const environment = {
  production: false,
  apiBase: 'https://devapis.invento.llc/api',
};
